const BXA=f=>(window.BX_IMG||{})[f]||'';
/* Lazy background images: 48 colour swatches + area cards sit below the fold; painting
   them all on load was ~3 MB on mobile. Set the hex now, the photo when near the viewport. */
const bxLazyIO = ('IntersectionObserver' in window) ? new IntersectionObserver(entries=>{
  entries.forEach(en=>{ if(en.isIntersecting){ const el=en.target; el.style.background = el.dataset.bxBg; delete el.dataset.bxBg; bxLazyIO.unobserve(el); } });
}, {rootMargin:'300px 0px'}) : null;
function lazyBg(el, css, fallback){
  if(bxLazyIO){ el.style.background = fallback || ''; el.dataset.bxBg = css; bxLazyIO.observe(el); }
  else el.style.background = css;
}

/* ============================================================
   BX prototype state machine · P1
   Placeholder pricing only — real BOM math lands in P4.
   ============================================================ */
const AREAS = [
  // tab res — ctx: wet / outdoor; surfaces: suggested calculator rows
  {key:'bathroom',  tab:'res', label:'Bathroom',            img:BXA('03-home-application-bathrooms-card.jpg'),            ctx:{wet:true,  outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'kitchen',   tab:'res', label:'Kitchen',             img:BXA('02-home-application-kitchens-card.jpg'),             ctx:{wet:false, outdoor:false}, surfaces:[{t:'wall'},{t:'benchtop'},{t:'ceiling'}]},
  {key:'living',    tab:'res', label:'Living Area',         img:BXA('04-home-application-living-spaces-card.jpg'),        ctx:{wet:false, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'bedroom',   tab:'res', label:'Bedroom',             img:BXA('11-home-testimonial-project-natural-wall-closeup-card.jpg'), ctx:{wet:false, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'floors',    tab:'res', label:'Floors',              img:BXA('05-home-application-floors-card.jpg'),               ctx:{wet:false, outdoor:false}, surfaces:[{t:'floor'}]},
  {key:'walls',     tab:'res', label:'Walls & Ceilings',    img:BXA('06-home-application-feature-walls-card.jpg'),        ctx:{wet:false, outdoor:false}, surfaces:[{t:'wall'},{t:'ceiling'}]},
  {key:'joinery',   tab:'res', label:'Joinery & Cabinetry', img:BXA('07-home-application-joinery-cabinetry-card.jpg'),    ctx:{wet:false, outdoor:false}, surfaces:[{t:'benchtop'}]},
  {key:'outdoor',   tab:'res', label:'Outdoor / Facade',    img:BXA('05-trade-project-outdoor-alfresco-card.jpg'),        ctx:{wet:true,  outdoor:true},  surfaces:[{t:'wall'},{t:'floor'}]},
  // tab com — commercial always gets the Poolcem build (wet:true → hydroshield): heavier
  // traffic, cleaning chemicals, spills. Renders: assets/com-*.jpg (concept images, 2026-09-22).
  {key:'office',     tab:'com', label:'Offices & Reception',        img:BXA('com-office-thumb.jpg'),     ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'retail',     tab:'com', label:'Retail & Shopfronts',        img:BXA('com-retail-thumb.jpg'),     ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'lobby',      tab:'com', label:'Hotel & Building Lobbies',   img:BXA('com-lobby-thumb.jpg'),      ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'cafe',       tab:'com', label:'Cafés & Bakeries',           img:BXA('com-cafe-thumb.jpg'),       ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'benchtop'}]},
  {key:'restaurant', tab:'com', label:'Bars & Restaurants',         img:BXA('com-restaurant-thumb.jpg'), ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'benchtop'}]},
  {key:'clinic',     tab:'com', label:'Medical & Dental Clinics',   img:BXA('com-clinic-thumb.jpg'),     ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
  {key:'gym',        tab:'com', label:'Gyms & Fitness Studios',     img:BXA('com-gym-thumb.jpg'),        ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'}]},
  {key:'showroom',   tab:'com', label:'Showrooms & Dealerships',    img:BXA('com-showroom-thumb.jpg'),   ctx:{wet:true, outdoor:false}, surfaces:[{t:'wall'},{t:'floor'},{t:'ceiling'}]},
];

/* CANONICAL 48-colour catalogue — mirrors snippets/mcf-colours-data.liquid
   (name ¦ code ¦ shade ¦ hex ¦ family ¦ best). Texture photo = assets/colour-<hex>.jpg */
const COLOURS = [
  ['Whitehaven','MCT-050','light','#f3efe6','Neutral',0],['Tarifa','MCT-050','mid','#ece6d8','Neutral',1],['Cottesloe','MCT-050','deep','#ada89d','Neutral',0],
  ['Bondi','MCT-140','light','#dfdad1','Neutral',0],['Sitges','MCT-140','mid','#cec6b8','Neutral',1],['Bronte','MCT-140','deep','#989287','Neutral',0],
  ['Noosa','MCT-200','light','#e6d8c3','Warm',0],['Byron','MCT-200','mid','#d8c3a2','Warm',0],['Marbella','MCT-200','deep','#9f8f77','Warm',0],
  ['Manly','MCT-120','light','#dbd0bd','Warm',0],['Tulum','MCT-120','mid','#c7b69a','Warm',0],['Positano','MCT-120','deep','#938672','Warm',0],
  ['Wineglass','MCT-240','light','#c5b8a9','Neutral',0],['Maroochydore','MCT-240','mid','#a6927a','Neutral',0],['Mooloolaba','MCT-240','deep','#7c6d5b','Neutral',0],
  ['Malibu','MCT-220','light','#cca991','Warm',0],['Cable Beach','MCT-220','mid','#b07a55','Warm',1],['Marrakech','MCT-220','deep','#835c42','Warm',0],
  ['St Tropez','MCT-800','light','#dbc38c','Warm',0],['Phuket','MCT-800','mid','#c7a24e','Warm',0],['Casablanca','MCT-800','deep','#93783d','Warm',0],
  ['Seminyak','MCT-700','light','#dcb382','Warm',0],['Copacabana','MCT-700','mid','#c98a3e','Warm',0],['Zanzibar','MCT-700','deep','#956831','Warm',0],
  ['Coral Bay','MCT-320','light','#cf8d80','Red',0],['Uluru','MCT-320','mid','#b5503c','Red',0],['Kimberley','MCT-320','deep','#873f30','Red',0],
  ['Provence','MCT-300','light','#aa8280','Red',0],['Bordeaux','MCT-300','mid','#7c3e3c','Red',0],['Ravello','MCT-300','deep','#5f3230','Red',0],
  ['Palm Cove','MCT-400','light','#a1a991','Green',0],['Costa Brava','MCT-400','mid','#6e7a55','Green',1],['Daintree','MCT-400','deep','#555c42','Green',0],
  ['Trinity','MCT-420','light','#b4bfa1','Green',0],['Tallow','MCT-420','mid','#8c9d6f','Green',0],['Eden','MCT-420','deep','#6a7554','Green',0],
  ['Santorini','MCT-500','light','#96abb4','Blue',0],['Ibiza','MCT-500','mid','#5e7e8c','Blue',1],['Capri','MCT-500','deep','#4a5f68','Blue',0],
  ['Miami','MCT-520','light','#a1c1c2','Blue',0],['Bora Bora','MCT-520','mid','#6fa0a1','Blue',0],['Whitsundays','MCT-520','deep','#567777','Blue',0],
  ['Lavender Bay','MCT-600','light','#b6afc5','Violet',0],['Monaco','MCT-600','mid','#8e84a6','Violet',0],['Portofino','MCT-600','deep','#6b637a','Violet',0],
  ['Bells','MCT-100','light','#767573','Dark',0],['Monte Carlo','MCT-100','mid','#2c2a27','Dark',1],['Tahiti','MCT-100','deep','#272421','Dark',0],
].map(([name,code,shade,hex,family,best])=>({name,code,shade,hex,family,best:!!best,img:BXA('colour-'+hex.slice(1)+'.jpg')}));
const colourBy = (code,shade)=>COLOURS.find(c=>c.code===code&&c.shade===shade);
const colourByName = n=>COLOURS.find(c=>c.name===n);

/* 5 curated palettes — verbatim from /pages/colours */
const PALETTES = [
  {eyebrow:'Coastal & cool', name:'Coastal Calm', desc:'Sea-washed blues and soft neutrals for a calm, breezy room.', names:['Santorini','Ibiza','Miami','Whitehaven']},
  {eyebrow:'Warm & quiet', name:'Warm Minimal', desc:'Creamy, sun-warmed tones for a soft, contemporary calm.', names:['Noosa','Byron','Manly','St Tropez']},
  {eyebrow:'Earthy & grounded', name:'Natural Stone', desc:'Greys and taupes that read like honest, quarried stone.', names:['Sitges','Maroochydore','Wineglass','Bronte']},
  {eyebrow:'Bold & dramatic', name:'Dark Statement', desc:'Deep, confident colour for feature walls with weight.', names:['Monte Carlo','Tahiti','Daintree','Ravello']},
  {eyebrow:'Fresh & gentle', name:'Soft Contemporary', desc:'Muted greens and chalky whites for a light, current feel.', names:['Palm Cove','Trinity','Bondi','Tarifa']},
];
const FAMILIES = [
  {key:'all', label:'All shades', dot:'#b9a78c'},
  {key:'best', label:'Best sellers ♥', dot:'#C18D52'},
  {key:'Neutral', label:'Neutrals', dot:'#cec6b8'},
  {key:'Warm', label:'Warm', dot:'#c19a6b'},
  {key:'Green', label:'Greens', dot:'#8c9d6f'},
  {key:'Blue', label:'Blues', dot:'#6fa0a1'},
  {key:'Red', label:'Reds', dot:'#b5503c'},
  {key:'Violet', label:'Violets', dot:'#8e84a6'},
  {key:'Dark', label:'Darks', dot:'#3a3733'},
];
const FINISHES = [
  {key:'smooth',  name:'Smooth',    desc:'Sleek and refined'},
  {key:'natural', name:'Natural',   desc:'Soft, organic feel'},
  {key:'textured',name:'Textured',  desc:'Subtle texture and movement'},
  {key:'softmatte',name:'Soft Matte',desc:'Low-sheen sophistication'},
];
const SURFACE_LABEL = {wall:'Wall', floor:'Floor', ceiling:'Ceiling', benchtop:'Benchtop'};

/* ── REAL pricing engine — same model as the kit configurator (mcf-product.js).
   Variant IDs + live prices come from window.MCF_CATALOG / window.BX_PRICING,
   printed server-side by mcf-experience.liquid. Every BOM line is a real cart
   line: {role, handle, name, pack, id (variant), qty, unit ($)}. ── */
const CATP = window.MCF_CATALOG || {};
const CFGP = window.BX_PRICING || {};
const variantsOf = h => (CATP[h] && CATP[h].variants) || [];
const variantBySku = (h, sku) => variantsOf(h).find(v => v.sku === sku);
const priceOf = v => (v.price || 0) / 100;
function parseSize(title, unit){
  if(!title) return null;
  const re = unit === 'L' ? /([\d.]+)\s*(?:l|litre|litres)\b/i : /([\d.]+)\s*kg/i;
  const m = title.match(re);
  return m ? parseFloat(m[1]) : null;
}
/* scale = how many pack-units one labelled unit really holds. Two-part kits label
   each part separately ("4 Litres Each" = 4 L of Part 1 + 4 L of Part 2 = 8 L mixed),
   so they carry packScale:2. Everything else is 1. */
function packsFor(h, unit, scale, forceUnits){
  const ptitle = (CATP[h] && CATP[h].title) || '';
  const k = scale || 1;
  return variantsOf(h).map(v => {
    /* forceUnits overrides whatever the product title claims. Plus Base is a 20 kg
       bucket (TDS M520A) but is still titled "…25kg" in Shopify — without this the
       BOM under-orders it by 20%. */
    const u = forceUnits || parseSize(v.title, unit) || parseSize(ptitle, unit);
    const label = parseSize(v.title, unit) ? v.title : (parseSize(ptitle, unit) ? ptitle.replace(/^.*?(\d)/, '$1') : v.title);
    return u ? { id: v.id, units: u * k, price: priceOf(v), title: label, sku: v.sku } : null;
  }).filter(Boolean);
}
/* min-cost combo of packs covering >= need (integer DP on ceil units) */
function bestCombo(need, packs){
  if(!packs.length || need <= 0) return [];
  const T = Math.max(1, Math.ceil(need));
  const INF = 1e12, dp = new Array(T + 1).fill(INF), pick = new Array(T + 1).fill(null);
  dp[0] = 0;
  for(let x = 0; x <= T; x++){
    if(dp[x] === INF) continue;
    for(const p of packs){
      const u = Math.max(1, Math.round(p.units));
      const nx = Math.min(T, x + u);
      if(dp[x] + p.price < dp[nx]){ dp[nx] = dp[x] + p.price; pick[nx] = { prev: x, p }; }
    }
  }
  const counts = {}; let k = T, guard = 0;
  while(k > 0 && pick[k] && guard++ < 999){
    const pr = pick[k], id = pr.p.id;
    counts[id] = counts[id] || { p: pr.p, qty: 0 };
    counts[id].qty++; k = pr.prev;
  }
  return Object.keys(counts).map(id => counts[id]);
}
const SEALER_HANDLE = {
  M561:'microestil-microshield', M560:'microestil-microshield',
  M577:'superiorseal-2k-part-a', M574:'superiorseal-2k-part-a',
  M579:'superiorseal-hardener-2k-part-b', M578:'superiorseal-hardener-2k-part-b',
  M528:'hidrofugante-w52', M527:'hidrofugante-w52'
};
const sysByKey = k => (CFGP.systems || []).find(s => s.key === k);
/* deterministic area+surface → system (the 2-axis model, same as mcf-product) */
/* Moisture and exposure decide the RANGE before anything else: Poolcem for every wet
   area and everything outdoors, Plus indoors and dry. Only then does the surface pick
   the finish — Medio on walls, floors and joinery; Fino on ceilings, which are not
   trafficable and where Medio reads heavier than it needs to. Fino never goes on a
   floor (Shae: "it looks too plasticky"). */
const systemForSurface = (a, t) =>
  a.ctx.outdoor ? 'hydrotuff' :
  a.ctx.wet ? 'hydroshield' :
  t === 'benchtop' ? 'craftcoat' :
  t === 'ceiling' ? 'ceilingcoat' :
  t === 'floor' ? 'floormaster' : 'wallmaster';
const ROLE_IMG = {
  'Primer':'10-product-card-surface-primer.jpg',
  'Reinforcement mesh':'11-product-card-microcement-base.jpg',
  'Base coat':'11-product-card-microcement-base.jpg',
  'Finish coat':'01-product-card-limestone-microcement-system.jpg',
  'Pre-sealer':'09-product-card-matte-sealer.jpg',
  'Sealer':'09-product-card-matte-sealer.jpg'
};
const ROLE_SUB = {
  'Primer':'Bonding primer, matched to what you are going over',
  'Reinforcement mesh':'Bedded into the first base coat · sold per m² (incl. 10% overlap)',
  'Base coat':'Structural microcement body · two coats, untinted',
  'Finish coat':'The seamless surface you touch · two tinted coats',
  'Colour toner':'Pigment mixed into both finish coats',
  'Pre-sealer':'Goes on before the sealer so the roller lays it evenly',
  'Sealer':'Protects & seals the surface · two coats'
};
const ROLE_ORDER = ['Primer','Reinforcement mesh','Base coat','Finish coat','Colour toner','Pre-sealer','Sealer'];
/* real BOM for one system + m² — mirrors mcf-product.js computeFor()

   Every microcement rate in BX_PRICING is PER COAT and every system is two base
   coats plus two tinted finish coats, so both get multiplied by `coats`. Sealer
   units_m2 is m² per pack per coat, multiplied by sealerCoats. Primers are a
   single coat and are never multiplied. */
function primerFor(){
  const subs = (CFGP.substrates || []);
  const sub = subs.find(x => x.key === state.substrate) || subs[0];
  if(!sub || sub.primer === 'none') return null;
  return (CFGP.primers || {})[sub.primer] || null;
}
function computeFor(s, m2){
  const coats = s.coats || 2, lines = [];

  /* PRIMER — one coat, and which one depends on the substrate the customer told us
     about in step 2, not on the system. Over a fresh waterproofing membrane there is
     no primer at all: the microcement goes straight onto it. */
  const pr = primerFor();
  if(pr && CATP[pr.handle]){
    bestCombo(m2 / pr.m2PerL, packsFor(pr.handle, 'L')).forEach(c =>
      lines.push({role:'Primer', handle:pr.handle, name:CATP[pr.handle].title, pack:c.p.title, id:c.p.id, qty:c.qty, unit:c.p.price,
                  rate:pr.m2PerL + ' m²/L · one coat'}));
  }

  /* MESH — on every system, walls included. The WallMaster spec says reinforcement
     is not required there; we include it anyway because joint movement in plasterboard
     is what cracks a finish, and the mesh is a rounding error against the repair. */
  if(CFGP.mesh){
    const mv = variantBySku(CFGP.mesh.handle, CFGP.mesh.sku) || variantsOf(CFGP.mesh.handle)[0];
    /* Mesh is sold by the square metre — the roll is 1 m wide, so 1 linear metre = 1 m².
       Sheets overlap ≥ 5 cm at every seam (Handbook p25 §8.1) → order a 10% allowance. */
    if(mv) lines.push({role:'Reinforcement mesh', handle:CFGP.mesh.handle, name:(CATP[CFGP.mesh.handle]||{}).title || 'Fibreglass mesh', pack:'', id:mv.id,
                       qty:Math.max(1, Math.ceil(m2 * (CFGP.mesh.overlap || 1.10))), unit:priceOf(mv),
                       rate:'bedded into the first base coat'});
  }

  /* BASE — two coats. This is the line that was being counted once. */
  const buildKg = m2 * s.build.kgPerM2 * coats;
  bestCombo(buildKg, packsFor(s.build.handle, 'kg', 1, s.build.packKg)).forEach(c =>
    lines.push({role:'Base coat', handle:s.build.handle, name:CATP[s.build.handle].title, pack:c.p.title, id:c.p.id, qty:c.qty, unit:c.p.price,
                rate:s.build.kgPerM2 + ' kg/m² × ' + coats + ' coats = ' + fmtKg(buildKg)}));

  /* FINISH — two coats, and the only coats that carry colour. */
  const finishKg = m2 * s.finish.kgPerM2 * coats;
  bestCombo(finishKg, packsFor(s.finish.handle, 'kg')).forEach(c =>
    lines.push({role:'Finish coat', handle:s.finish.handle, name:CATP[s.finish.handle].title, pack:c.p.title, id:c.p.id, qty:c.qty, unit:c.p.price,
                rate:s.finish.kgPerM2 + ' kg/m² × ' + coats + ' coats = ' + fmtKg(finishKg)}));

  /* TONER — dosed off the finish coats only; the base stays untinted. The ratio is the
     Plus Medio baseline for the chosen depth times this product's scale factor (Toner
     Ratios, Mar 25), then capped: the table runs to 75 ml/kg on F4 at the deepest shade,
     which no applicator uses and the product will not absorb. */
  const pc = state.colour ? colourBy(state.colour, state.depth) : null;
  const ton = pc ? (CFGP.toners || []).find(t => t.code === pc.code) : null;
  const tv = ton ? variantBySku('microestil-colour-toner-250ml', ton.sku) : null;
  if(tv){
    const raw = ((CFGP.depths || {})[state.depth] || 15) * s.finish.scale;
    const mlkg = Math.min(raw, CFGP.toner_max_mlkg || 30);
    const ml = finishKg * mlkg;
    const bottles = Math.max(1, Math.ceil(ml / (CFGP.bottle_ml || 250)));
    lines.push({role:'Colour toner', handle:'microestil-colour-toner-250ml', name:pc.name + ' toner (' + pc.code + ') · 250ml', pack:'', id:tv.id,
                qty:bottles, unit:priceOf(tv), colour:true,
                rate:round1(mlkg) + ' ml/kg into ' + fmtKg(finishKg) + ' of finish' + (raw > mlkg ? ' · capped' : '')});
  }

  /* PRE-SEALER — Superiorseal Primer, one coat, only where the 2K sealer is used.
     Without it the roller grabs and the sealer lays unevenly. */
  if(s.presealer && CFGP.presealer && CATP[CFGP.presealer.handle]){
    const ps = CFGP.presealer;
    bestCombo(m2 / ps.m2PerUnit, packsFor(ps.handle, ps.unit || 'kg')).forEach(c =>
      lines.push({role:'Pre-sealer', handle:ps.handle, name:CATP[ps.handle].title, pack:c.p.title, id:c.p.id, qty:c.qty, unit:c.p.price,
                  rate:ps.m2PerUnit + ' m²/L · one coat, before the sealer'}));
  }

  /* SEALER — units_m2 is m² per pack for ONE coat, so multiply by the coat count. */
  const units = Math.max(1, Math.ceil((m2 * s.sealerCoats) / s.sealer.units_m2));
  s.sealer.parts.forEach(p => {
    const h = SEALER_HANDLE[p.sku], v = h && variantBySku(h, p.sku);
    if(v) lines.push({role:'Sealer', handle:h, name:CATP[h].title, pack:v.title, id:v.id, qty:units * (p.qtyPer || 1), unit:priceOf(v),
                      rate:s.sealerCoats + ' coats over ' + round1(m2) + ' m²'});
  });
  return lines;
}
const round1 = n => Math.round(n * 10) / 10;
const fmtKg = n => (n >= 10 ? Math.round(n) : round1(n)) + ' kg';

const isLightHex = hex => { const [r,g,b]=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)); return (r*.299+g*.587+b*.114)>150; };

/* ── state ─────────────────────────────────────────────── */
const DEFAULT_STATE = {areas:[], tab:'res', colour:null, depth:'mid', family:'all', palette:null, finish:null, substrate:'bare', rows:{}, removed:{}};
let state = load();
function load(){
  try{ const s = JSON.parse(localStorage.getItem('bx-state-v2')); if(s && Array.isArray(s.areas)) return {...structuredClone(DEFAULT_STATE), ...s}; }catch(e){}
  return structuredClone(DEFAULT_STATE);
}
function save(){ try{ localStorage.setItem('bx-state-v2', JSON.stringify(state)); }catch(e){} syncURL(); }
function syncURL(){
  const p = new URLSearchParams();
  if(state.areas.length) p.set('areas', state.areas.join(','));
  if(state.colour) { p.set('colour', state.colour); p.set('shade', state.depth); }
  if(state.finish) p.set('finish', state.finish);
  history.replaceState(null,'', p.toString() ? '?'+p.toString() : location.pathname);
}
(function fromURL(){
  const p = new URLSearchParams(location.search);
  if(p.get('areas')) state.areas = p.get('areas').split(',').filter(k=>AREAS.some(a=>a.key===k));
  if(p.get('colour')) state.colour = p.get('colour');
  if(p.get('shade')) state.depth = p.get('shade');
  if(p.get('finish')) state.finish = p.get('finish');
  // seed suggested rows for any area that arrived without them (URL entry, older saves)
  state.areas.forEach(k=>{
    if(!state.rows[k] || !state.rows[k].length){
      state.rows[k] = AREAS.find(a=>a.key===k).surfaces.map(s=>({t:s.t, mode:'dims', a:'', b:'', m2:''}));
    }
  });
})();

const $ = s => document.querySelector(s);
const area = k => AREAS.find(a=>a.key===k);
const money = n => '$'+n.toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});

/* ── step 1 · areas ────────────────────────────────────── */
function renderAreas(){
  const wrap = $('#bx-areas');
  wrap.innerHTML = '';
  AREAS.filter(a=>a.tab===state.tab).forEach(a=>{
    const sel = state.areas.includes(a.key);
    const b = document.createElement('button');
    b.type='button'; b.className='bx-area'+(sel?' is-sel':''); b.setAttribute('aria-pressed', sel);
    b.innerHTML = `
      <span class="bx-area__img" data-bx-bg="url('${a.img}') center/cover"></span>
      <span class="bx-area__ctx">
        <span>${a.tab==='com'?'High-traffic':a.ctx.wet?'Wet':'Dry'}</span><span>${a.ctx.outdoor?'Outdoor':'Indoor'}</span>
      </span>
      <span class="bx-area__check"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>
      <span class="bx-area__label">${a.label}</span>`;
    b.addEventListener('click', ()=>toggleArea(a.key));
    const ai=b.querySelector('.bx-area__img'); if(ai){ if(bxLazyIO){ bxLazyIO.observe(ai); } else { ai.style.background = ai.dataset.bxBg; } }
    wrap.appendChild(b);
  });
  ['res','com'].forEach(t=>{
    const n = state.areas.filter(k=>area(k).tab===t).length;
    $('#bx-count-'+t).textContent = n ? ' · '+n : '';
  });
  renderSelbar();
}
function toggleArea(key){
  if(state.areas.includes(key)){
    state.areas = state.areas.filter(k=>k!==key);
    delete state.rows[key];
  } else {
    state.areas = [...state.areas, key];
    state.rows = {...state.rows, [key]: area(key).surfaces.map(s=>({t:s.t, mode:'dims', a:'', b:'', m2:''}))};
  }
  save(); renderAreas(); renderDerived(); markCartDirty();
}
function renderSelbar(){
  const bar = $('#bx-selbar'), chips = $('#bx-selchips');
  bar.hidden = !state.areas.length;
  chips.innerHTML = '';
  state.areas.forEach(k=>{
    const b = document.createElement('button');
    b.type='button'; b.className='bx-selchip';
    b.innerHTML = `${area(k).label} <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>`;
    b.addEventListener('click', ()=>toggleArea(k));
    chips.appendChild(b);
  });
}

/* ── derived context ───────────────────────────────────── */
function ctxOf(){
  const sel = state.areas.map(area);
  return {
    wet: sel.some(a=>a.ctx.wet), dry: sel.some(a=>!a.ctx.wet),
    out: sel.some(a=>a.ctx.outdoor), ind: sel.some(a=>!a.ctx.outdoor),
    any: sel.length>0
  };
}
function renderDerived(){ renderConditions(); renderSubstrate(); renderSystems(); renderGroups(); renderSummary(); }

/* ── step 2 · what are we going over? — this is what picks the primer ──
   Bare board drinks water, so it gets the porous primer. Anything painted or tiled
   has little or no suction and needs the smooth primer for a mechanical key. Over a
   fresh waterproofing membrane nothing is primed at all — the microcement bonds to
   the membrane directly. */
function renderSubstrate(){
  const w = $('#bx-substrate-opts'); if(!w) return;
  const subs = (CFGP.substrates || []);
  w.innerHTML = '';
  subs.forEach(sub=>{
    const on = state.substrate === sub.key;
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'bx-sub' + (on ? ' is-on' : '');
    b.setAttribute('role','radio'); b.setAttribute('aria-checked', on);
    b.innerHTML = `<b>${sub.label}</b><span>${sub.sub}</span>`;
    b.addEventListener('click', ()=>{
      state.substrate = sub.key; save();
      renderSubstrate(); renderGroups(); renderSummary(); markCartDirty();
    });
    w.appendChild(b);
  });
  const out = $('#bx-substrate-out');
  if(out){
    const pr = primerFor();
    out.innerHTML = pr && CATP[pr.handle]
      ? `Your kit ships with <b>${CATP[pr.handle].title}</b> — one coat at ${pr.m2PerL} m² per litre.`
      : `No primer needed — microcement goes straight over the membrane.`;
  }
}

function segHTML(opts){ return opts.map(o=>`<span class="bx-seg__opt${o.on?' is-on':''}">${o.label}</span>`).join(''); }
function renderConditions(){
  const c = ctxOf();
  $('#bx-seg-type').innerHTML = !c.any
    ? segHTML([{label:'Dry area'},{label:'Wet area'}])
    : (c.wet&&c.dry) ? segHTML([{label:'Multi — Dry + Wet',on:true}])
    : segHTML([{label:'Dry area',on:c.dry},{label:'Wet area',on:c.wet}]);
  $('#bx-seg-loc').innerHTML = !c.any
    ? segHTML([{label:'Indoor'},{label:'Outdoor'}])
    : (c.ind&&c.out) ? segHTML([{label:'Multi — Indoor + Outdoor',on:true}])
    : segHTML([{label:'Indoor',on:c.ind},{label:'Outdoor',on:c.out}]);
}

/* ── step 3 · systems ──────────────────────────────────── */
function sysCard({name, forLabel, rec, dim, imgs, points, badge}){
  return `<div class="bx-sys${rec?' is-rec':''}${dim?' is-dim':''}">
    ${badge?'<span class="bx-sys__badge">Recommended</span>':''}
    <p class="bx-sys__for">${forLabel||''}</p>
    <p class="bx-sys__name">${name}</p>
    <div class="bx-sys__imgs">${imgs.map(i=>`<img src="${i}" alt="" loading="lazy">`).join('')}</div>
    <ul>${points.map(p=>`<li><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>${p}</li>`).join('')}</ul>
  </div>`;
}
const SYS_WET = {name:'Wet Area System', imgs:[BXA('10-product-card-surface-primer.jpg'),BXA('11-product-card-microcement-base.jpg'),BXA('09-product-card-matte-sealer.jpg')],
  points:['Poolcem range — the only build we put in a wet area or outdoors','Two coats of F6 with fibreglass mesh, then two tinted coats of F4','Outdoor surfaces sealed with breathable Microshield — never the airtight indoor sealer','Ideal for bathrooms, showers, benchtops with a sink and outdoor areas']};
const SYS_DRY = {name:'Dry Area System', imgs:[BXA('01-product-card-limestone-microcement-system.jpg'),BXA('11-product-card-microcement-base.jpg'),BXA('09-product-card-matte-sealer.jpg')],
  points:['Plus range — for dry indoor spaces: living areas, bedrooms, joinery','Two base coats with mesh on every surface, then two tinted finish coats','Walls, floors and joinery finish in Medio; ceilings finish in Fino','Every layer included: primer, mesh, base, finish, toner, sealer']};
function renderSystems(){
  const c = ctxOf(), w = $('#bx-systems');
  const wetAreas = state.areas.filter(k=>area(k).ctx.wet).map(k=>area(k).label).join(' · ');
  const dryAreas = state.areas.filter(k=>!area(k).ctx.wet).map(k=>area(k).label).join(' · ');
  if(!c.any){
    w.innerHTML = sysCard({...SYS_DRY, forLabel:'Dry indoor spaces', dim:true, points:SYS_DRY.points})
                + sysCard({...SYS_WET, forLabel:'Wet & exterior zones', dim:true, points:SYS_WET.points});
    $('#bx-sys-hint').textContent = 'Select your areas in step 1 and your system appears here.';
    return;
  }
  let html = '';
  if(c.wet) html += sysCard({...SYS_WET, forLabel:'For: '+wetAreas, rec:true, badge:true});
  if(c.dry) html += sysCard({...SYS_DRY, forLabel:'For: '+dryAreas, rec:true, badge:!c.wet});
  if(!c.wet) html += sysCard({...SYS_WET, forLabel:'Wet & exterior zones', dim:true});
  if(!c.dry) html += sysCard({...SYS_DRY, forLabel:'Dry indoor spaces', dim:true});
  w.innerHTML = html;
  $('#bx-sys-hint').textContent = (c.wet&&c.dry)
    ? 'Multi-zone project — each area gets its own system, sized together in one cart.'
    : 'Matched to your areas automatically. The other system stays available if your plans change.';
}

/* ── step 4 · colour (canonical 48 catalogue + palettes) ── */
function renderFamilies(){
  const w = $('#bx-fam'); w.innerHTML='';
  FAMILIES.forEach(f=>{
    const b = document.createElement('button');
    b.type='button'; b.className='bx-fam__b'+(!state.palette && state.family===f.key?' is-on':'');
    b.innerHTML = `<span class="dot" style="background:${f.dot}"></span>${f.label}`;
    b.addEventListener('click', ()=>{ state.family=f.key; state.palette=null; save(); renderFamilies(); renderPalettes(); renderSwatches(); });
    w.appendChild(b);
  });
}
function renderPalettes(){
  const w = $('#bx-pal-track'); w.innerHTML='';
  const ROT = [['-9deg','-15deg','6px','0px'],['-3deg','-5deg','0px','-4px'],['3deg','5deg','0px','-4px'],['9deg','15deg','6px','0px']];
  PALETTES.forEach(p=>{
    const b = document.createElement('button');
    b.type='button'; b.className='bx-pal'+(state.palette===p.name?' is-on':'');
    b.setAttribute('aria-label', `Show the ${p.name} palette`);
    b.innerHTML = `<span class="bx-pal__fan" aria-hidden="true">${p.names.map((n,i)=>{
        const c = colourByName(n); const [rot,roth,ty,tyh] = ROT[i];
        return `<span class="bx-pal__chip" style="background-color:${c.hex};background-image:url('${c.img}');--rot:${rot};--rot-h:${roth};--ty:${ty};--ty-h:${tyh}"></span>`;
      }).join('')}</span>
      <span class="bx-pal__body">
        <span class="bx-pal__eyebrow">${p.eyebrow}</span>
        <span class="bx-pal__name">${p.name}</span>
        <span class="bx-pal__desc">${p.desc}</span>
      </span>`;
    b.addEventListener('click', ()=>{
      state.palette = state.palette===p.name ? null : p.name; save();
      renderPalettes(); renderFamilies(); renderSwatches();
    });
    w.appendChild(b);
  });
  const clear = $('#bx-palclear');
  clear.classList.toggle('is-on', !!state.palette);
  if(state.palette){ clear.innerHTML = `${state.palette} palette — showing 4 shades &nbsp;✕ clear`; }
}
function swatchBtn(c){
  const light = isLightHex(c.hex);
  const b = document.createElement('button');
  b.type='button';
  b.className = 'bx-sw'+(state.colour===c.code && state.depth===c.shade ?' is-sel':'');
  b.style.setProperty('--c', c.hex);
  lazyBg(b, `url('${c.img}') center/cover, ${c.hex}`, c.hex);
  b.style.setProperty('--tx', light ? 'rgba(23,21,18,.82)' : '#fffaf2');
  b.setAttribute('aria-label', `${c.name} — ${c.shade}`);
  b.innerHTML = `${c.best?'<span class="bx-sw__best">♥ Best</span>':''}
    <span class="bx-sw__check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>
    <span class="bx-sw__name">${c.name}</span>`;
  b.addEventListener('click', ()=>{ state.colour=c.code; state.depth=c.shade; save();
    renderSwatches(); renderAllGrid(); renderPicked(); renderSummary(); document.querySelectorAll('#bx-depth button').forEach(x=>x.classList.toggle('is-on',x.dataset.depth===c.shade)); });
  return b;
}
function renderSwatches(){
  const w = $('#bx-swatches'); w.innerHTML='';
  let list;
  if(state.palette){
    list = PALETTES.find(p=>p.name===state.palette).names.map(colourByName);
  } else if(state.family==='best'){
    list = COLOURS.filter(c=>c.best);
  } else {
    list = COLOURS.filter(c=>c.shade===state.depth && (state.family==='all'||c.family===state.family));
  }
  list.forEach((c,i)=>{ const b=swatchBtn(c); b.style.transitionDelay=(i*22)+'ms'; w.appendChild(b); });
}
/* full 48 grid — Breno order: each group strictly LIGHT → DARK by real luminance;
   colours grouped by temperature (yellows → reds → greens → blues → violets),
   light → dark inside each temperature subgroup. */
const lum = hex => { const [r,g,b]=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)); return r*.299+g*.587+b*.114; };
const byLum = codes => COLOURS.filter(c=>codes.includes(c.code)).sort((a,b)=>lum(b.hex)-lum(a.hex));
const GRID_GROUPS = [
  {title:'Earthy & sand — light to dark', subs:[['MCT-050','MCT-140','MCT-200','MCT-120','MCT-240','MCT-220']]},
  {title:'Greys & darks — light to dark', subs:[['MCT-100']]},
  {title:'Colours — yellows → reds → greens → blues → violets', subs:[
    ['MCT-800','MCT-700'], // yellows/golds
    ['MCT-320','MCT-300'], // reds
    ['MCT-400','MCT-420'], // greens
    ['MCT-500','MCT-520'], // blues
    ['MCT-600'],           // violets
  ]},
];
function renderAllGrid(){
  const w = $('#bx-allgrid'); w.innerHTML='';
  GRID_GROUPS.forEach(g=>{
    const h = document.createElement('h4'); h.textContent = g.title; w.appendChild(h);
    const grid = document.createElement('div'); grid.className='bx-swatches';
    g.subs.forEach(codes=>byLum(codes).forEach(c=>grid.appendChild(swatchBtn(c))));
    w.appendChild(grid);
  });
}
function renderPicked(){
  const el = $('#bx-picked');
  const c = state.colour ? colourBy(state.colour, state.depth) : null;
  if(!c){ el.classList.remove('is-in'); return; }
  el.classList.add('is-in');
  const chip = el.querySelector('.chip');
  chip.style.background = `url('${c.img}') center/cover, ${c.hex}`;
  $('#bx-picked-name').textContent = c.name;
  $('#bx-picked-sub').textContent = `${c.code} · ${c.shade} dose · one colour across your whole project`;
}

/* ── step 5 · finish ───────────────────────────────────── */
const FIN_FILTER = {smooth:'saturate(.9) brightness(1.06)', natural:'none', textured:'contrast(1.18)', softmatte:'saturate(.75) brightness(.97)'};
function renderFinishes(){
  const w = $('#bx-finishes'); w.innerHTML='';
  FINISHES.forEach(f=>{
    const b = document.createElement('button');
    b.type='button'; b.className='bx-fin'+(state.finish===f.key?' is-sel':'');
    b.innerHTML = `<span class="bx-fin__check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>
      <span class="bx-fin__swatch" style="filter:${FIN_FILTER[f.key]}"></span>
      <span class="bx-fin__name">${f.name}</span>
      <span class="bx-fin__desc">${f.desc}</span>`;
    b.addEventListener('click', ()=>{ state.finish = state.finish===f.key ? null : f.key; save(); renderFinishes(); renderSummary(); });
    w.appendChild(b);
  });
}

/* ── step 6 · estimator ────────────────────────────────── */
function rowM2(r){
  if(r.mode==='m2') return parseFloat(r.m2)||0;
  return (parseFloat(r.a)||0)*(parseFloat(r.b)||0);
}
/* ── BOM builder — REAL kit maths per area, surfaces resolved to systems ── */
function groupBOM(k){
  const a = area(k), rows = state.rows[k]||[];
  const bySys = {};
  rows.forEach(r=>{
    const m = rowM2(r); if(!m) return;
    const sk = systemForSurface(a, r.t);
    bySys[sk] = (bySys[sk]||0) + m;
  });
  const items = []; let total = 0;
  Object.keys(bySys).forEach(sk=>{
    const s = sysByKey(sk); if(!s) return;
    total += bySys[sk];
    computeFor(s, bySys[sk]).forEach(l=>{
      items.push({key:`${k}:${sk}:${l.role}:${l.id}`, sysLabel:s.label, sysKey:sk, ...l});
    });
  });
  return {items, total};
}
function bomAll(){
  let m2 = 0, cost = 0; const groups = [], live = new Set();
  state.areas.forEach(k=>{
    const {items, total} = groupBOM(k);
    items.forEach(i => live.add(i.key));
    const active = items.filter(i=>!state.removed[i.key]);
    m2 += total;
    cost += active.reduce((s,i)=>s + i.qty * i.unit, 0);
    groups.push({k, items, total});
  });
  pruneRemoved(live);
  const off = Object.keys(state.removed).length;
  return {m2, cost, groups, removedCount: off, allOff: off > 0 && groups.every(g => g.items.every(i => state.removed[i.key]))};
}
/* An exclusion is keyed by area + system + role + variant, so it only means anything
   while that exact line is still in the kit. Change the substrate and the primer
   becomes a different product under a different key — the old exclusion then sits in
   localStorage for ever, invisible, and silently re-applies if the customer ever
   switches back. That is where the ghost lines came from. Anything no longer in the
   current BOM gets dropped here, every time the BOM is built. */
function pruneRemoved(live){
  const keys = Object.keys(state.removed);
  if(!keys.length) return;
  const keep = {};
  let dropped = false;
  keys.forEach(k => { if(live.has(k)) keep[k] = true; else dropped = true; });
  if(dropped){ state.removed = keep; save(); }
}
function restoreAll(){
  if(!Object.keys(state.removed).length) return;
  state.removed = {};
  save(); renderCart(); renderSummary(); markCartDirty();
}
function renderGroups(){
  const w = $('#bx-groups');
  if(!state.areas.length){
    w.innerHTML = '<div class="bx-est-empty">Select at least one project area in step 1 and your calculator appears here, pre-filled with the surfaces that space usually needs.</div>';
    return;
  }
  w.innerHTML = '';
  state.areas.forEach(k=>{
    const a = area(k);
    const rows = state.rows[k] || [];
    const g = document.createElement('div'); g.className='bx-group';
    const gm2 = rows.reduce((s,r)=>s+rowM2(r),0);
    g.innerHTML = `<div class="bx-group__head">
        <span class="bx-group__name">${a.label}</span>
        <span class="bx-group__ctx ${a.ctx.outdoor?'is-out':a.ctx.wet?'is-wet':''}">${a.ctx.outdoor?'Outdoor · Wet system':a.tab==='com'?'Commercial · high-traffic build':a.ctx.wet?'Wet area':'Dry area'}</span>
        <span class="bx-group__m2">${gm2 ? gm2.toFixed(1)+' m²' : '—'}</span>
      </div>
      <div class="bx-rows"></div>`;
    const rowsEl = g.querySelector('.bx-rows');
    rows.forEach((r,i)=>{
      const isWall = r.t==='wall';
      const row = document.createElement('div'); row.className='bx-row';
      row.innerHTML = `
        <select class="bx-row__surface" aria-label="Surface type">
          ${Object.entries(SURFACE_LABEL).map(([v,l])=>`<option value="${v}"${r.t===v?' selected':''}>${l}</option>`).join('')}
        </select>
        <div class="bx-row__dims">
          <input class="bx-in" type="number" min="0" step="0.1" inputmode="decimal" placeholder="${isWall?'Length (m)':'Length (m)'}" value="${r.a}" data-f="a" ${r.mode==='m2'?'disabled':''}>
          <span class="bx-x">×</span>
          <input class="bx-in" type="number" min="0" step="0.1" inputmode="decimal" placeholder="${isWall?'Height (m)':'Width (m)'}" value="${r.b}" data-f="b" ${r.mode==='m2'?'disabled':''}>
          <span class="bx-or">or</span>
          <input class="bx-in bx-in--m2" type="number" min="0" step="0.1" inputmode="decimal" placeholder="Total m²" value="${r.m2}" data-f="m2">
        </div>
        <span class="bx-row__m2">${rowM2(r) ? rowM2(r).toFixed(1)+' m²' : '&nbsp;'}</span>
        <button class="bx-row__del" type="button" aria-label="Remove surface">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>`;
      row.querySelector('select').addEventListener('change', e=>{ updateRow(k,i,{t:e.target.value}); });
      row.querySelectorAll('.bx-in').forEach(inp=>{
        inp.addEventListener('input', e=>{
          const f = e.target.dataset.f;
          const patch = {[f]: e.target.value};
          if(f==='m2'){
            patch.mode = e.target.value ? 'm2' : 'dims';
            if(e.target.value){ // a typed total replaces the length × width — clear them so it reads as one number, not two
              patch.a = ''; patch.b = '';
              row.querySelectorAll('.bx-in[data-f="a"],.bx-in[data-f="b"]').forEach(x=>{ x.value=''; x.disabled=true; });
            } else {
              row.querySelectorAll('.bx-in[data-f="a"],.bx-in[data-f="b"]').forEach(x=>{ x.disabled=false; });
            }
          }
          updateRow(k,i,patch,true);
        });
      });
      row.querySelector('.bx-row__del').addEventListener('click', ()=>{ state.rows[k] = rows.filter((_,x)=>x!==i); save(); renderGroups(); renderSummary(); });
      rowsEl.appendChild(row);
    });
    const add = document.createElement('button');
    add.type='button'; add.className='bx-addrow';
    add.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg> Click here to add another surface to ${a.label}`;
    add.addEventListener('click', ()=>{ state.rows[k] = [...rows, {t:'wall', mode:'dims', a:'', b:'', m2:''}]; save(); renderGroups(); });
    rowsEl.appendChild(add);
    w.appendChild(g);
  });
}
function updateRow(k,i,patch,soft){
  state.rows[k] = state.rows[k].map((r,x)=> x===i ? {...r,...patch} : r);
  save();
  if(soft){ // refresh computed cells without rebuilding inputs (keeps focus)
    const g = [...document.querySelectorAll('#bx-groups .bx-group')][state.areas.indexOf(k)];
    if(g){
      const rows = state.rows[k];
      const gm2 = rows.reduce((s,r)=>s+rowM2(r),0);
      g.querySelector('.bx-group__m2').textContent = gm2 ? gm2.toFixed(1)+' m²' : '—';
      const cell = g.querySelectorAll('.bx-row__m2')[i];
      if(cell) cell.innerHTML = rowM2(rows[i]) ? rowM2(rows[i]).toFixed(1)+' m²' : '&nbsp;';
    }
    renderSummary();
  } else { renderGroups(); renderSummary(); }
}

/* ── summary + pricing (BOM-driven, placeholder prices) ── */
function totals(){
  const {m2, cost} = bomAll();
  return {m2, cost};
}
let lastCost = 0;
function renderSummary(){
  const c = ctxOf(), {m2, cost} = totals();
  const sel = state.areas.map(k=>area(k).label);
  $('#bx-sum-areas').textContent = !sel.length ? '—' : sel.length<=2 ? sel.join(' + ') : sel.length+' areas';
  $('#bx-sum-type').textContent = !c.any ? '—' : (c.wet&&c.dry) ? 'Multi — Dry + Wet' : c.wet ? 'Wet area' : 'Dry area';
  $('#bx-sum-loc').textContent = !c.any ? '—' : (c.ind&&c.out) ? 'Indoor + Outdoor' : c.out ? 'Outdoor' : 'Indoor';
  $('#bx-sum-sys').textContent = !c.any ? '—' : (c.wet&&c.dry) ? 'Wet + Dry systems' : c.wet ? 'Wet Area System' : 'Dry Area System';
  const pc = state.colour ? colourBy(state.colour, state.depth) : null;
  $('#bx-sum-colour').innerHTML = pc ? `<span class="chip" style="background:url('${pc.img}') center/cover, ${pc.hex}"></span>${pc.name}` : '—';
  $('#bx-sum-finish').textContent = state.finish ? FINISHES.find(f=>f.key===state.finish).name : '—';
  $('#bx-sum-m2').textContent = m2 ? m2.toFixed(1)+' m²' : '—';
  const tv = $('#bx-sum-total');
  tv.textContent = money(cost);
  if(cost!==lastCost){ tv.classList.remove('is-bump'); void tv.offsetWidth; tv.classList.add('is-bump'); lastCost = cost; }
  $('#bx-sum-pay').textContent = cost>0 ? 'Primer, mesh, base, finish, toner & sealer — all sized in, GST incl.' : 'Add your areas and measurements to see your price.';
  $('#bx-dock-total').textContent = money(cost);
  renderStepsDone();
  /* Every change that touches the BOM ends up here, so an open drawer is redrawn from
     the same pass. Without this the excluded-items notice could still be quoting a
     count that was pruned two clicks earlier — the numbers were right, the label was
     stale. Guarded so renderCart -> renderSummary can never bounce back. */
  if(!redrawingCart){
    const d = $('#bx-cart');
    if(d && d.classList.contains('is-open')){
      redrawingCart = true;
      try { renderCart(); } finally { redrawingCart = false; }
    }
  }
}
let redrawingCart = false;
function renderStepsDone(){
  const c = ctxOf(), {m2} = totals();
  const done = {1:c.any, 2:c.any, 3:c.any, 4:!!state.colour, 5:!!state.finish, 6:m2>0, 7:false};
  document.querySelectorAll('.bx-step.is-required').forEach(sec=>{ if(done[+sec.dataset.step]) clearRequired(); });
  document.querySelectorAll('.bx-step').forEach(s=>{
    const n = +s.dataset.step;
    s.classList.toggle('is-done', !!done[n]);
    if(done[n]) s.querySelector('.bx-step__num').innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    else s.querySelector('.bx-step__num').textContent = n;
  });
  const next = [1,4,5,6].find(n=>!done[n]);
  $('#bx-dock-step').textContent = next ? `Step ${next} of 7` : 'Ready to order';
  $('#bx-dock-cta').textContent = next ? 'Continue ↓' : 'Add to cart →';
  $('#bx-dock-cta').onclick = ()=> next
    ? document.getElementById('bx-step-'+next).scrollIntoView({behavior:'smooth'})
    : openAndSave();
}

/* ── cart drawer — full BOM breakdown, per-line remove/add ── */
function renderCart(){
  const {m2, cost, groups, removedCount, allOff} = bomAll();
  /* Removing a line is easy to do and, until now, impossible to undo without knowing
     which lines you had removed. Say it plainly and give one control to reverse it. */
  const ex = $('#bx-cart-excluded'), ext = $('#bx-excluded-text');
  if(ex && ext){
    ex.hidden = !removedCount;
    ex.classList.toggle('is-empty', !!allOff);
    ext.textContent = allOff
      ? 'Every item is excluded — there is nothing to order.'
      : removedCount + (removedCount === 1 ? ' item is' : ' items are') + " excluded from your kit. You won't be charged for them.";
  }
  const w = $('#bx-cart-groups'); w.innerHTML='';
  const pc = state.colour ? colourBy(state.colour, state.depth) : null;
  groups.forEach(({k, items, total})=>{
    if(!items.length) return;
    const a = area(k);
    const g = document.createElement('div'); g.className='bx-cgrp';
    g.innerHTML = `<div class="bx-cgrp__head">
        <span class="bx-cgrp__name">${a.label}</span>
        <span class="bx-cgrp__chip ${a.ctx.outdoor?'is-out':a.ctx.wet?'is-wet':''}">${a.ctx.outdoor?'Outdoor system':a.ctx.wet?'Wet area system':'Dry area system'}</span>
        <span class="bx-cgrp__m2">${total.toFixed(1)} m²</span>
      </div>`;
    const sysNames = [...new Set(items.map(i=>i.sysLabel).filter(Boolean))];
    if(sysNames.length){
      const note = document.createElement('p');
      note.className = 'bx-cgrp__sys';
      note.textContent = sysNames.join(' + ') + ' · 2 base coats with mesh, 2 tinted finish coats';
      g.appendChild(note);
    }
    items.slice().sort((a,b)=>ROLE_ORDER.indexOf(a.role)-ROLE_ORDER.indexOf(b.role)).forEach(i=>{
      const off = !!state.removed[i.key];
      const line = document.createElement('div');
      line.className = 'bx-cline'+(off?' is-off':'');
      const isToner = i.role==='Colour toner';
      const img = ROLE_IMG[i.role] ? BXA(ROLE_IMG[i.role]) : '';
      const visual = isToner && pc
        ? `<span class="bx-cline__sw" style="background-image:url('${pc.img}'),linear-gradient(${pc.hex},${pc.hex})"></span>`
        : img ? `<img class="bx-cline__img" src="${img}" alt="" loading="lazy">`
        : `<span class="bx-cline__sw" style="background:var(--mcf-stone)"></span>`;
      const pack = i.pack && !/default title/i.test(i.pack) && i.name.toLowerCase().indexOf(i.pack.toLowerCase()) < 0 ? ' · ' + i.pack : '';
      line.innerHTML = `${visual}
        <div>
          <div class="bx-cline__name">${i.name}${pack}</div>
          <div class="bx-cline__sub">${ROLE_SUB[i.role] || i.role}</div>
          ${i.rate ? `<span class="bx-cline__rate">${i.rate}</span>` : ''}
        </div>
        <div>
          <div class="bx-cline__price">${money(i.qty * i.unit)}</div>
          <div class="bx-cline__qty">${i.qty} × ${money(i.unit)}</div>
        </div>
        <button class="bx-cline__tog" type="button">${off?'Add back':'Remove'}</button>`;
      line.querySelector('.bx-cline__tog').addEventListener('click', ()=>{
        state.removed = {...state.removed, [i.key]: !off};
        if(!state.removed[i.key]) delete state.removed[i.key];
        save(); renderCart(); renderSummary(); markCartDirty();
      });
      g.appendChild(line);
    });
    w.appendChild(g);
  });
  $('#bx-cart-meta').textContent = state.areas.map(k=>area(k).label).join(' + ') + (pc ? ` · ${pc.name}` : '') + (state.finish ? ` · ${FINISHES.find(f=>f.key===state.finish).name} finish` : '');
  $('#bx-cart-m2').textContent = m2 ? m2.toFixed(1)+' m²' : '—';
  $('#bx-cart-perm2').textContent = m2 ? money(cost/m2)+' / m²' : '—';
  $('#bx-cart-total').textContent = money(cost);
}
function openCart(){
  const {m2} = bomAll();
  if(!state.areas.length || !m2){ document.getElementById('bx-step-'+(!state.areas.length?1:6)).scrollIntoView({behavior:'smooth'}); return; }
  renderCart();
  $('#bx-cart').classList.add('is-open');
  $('#bx-cart').setAttribute('aria-hidden','false');
  $('#bx-cart-veil').classList.add('is-open');
}
function closeCart(){
  $('#bx-cart').classList.remove('is-open');
  $('#bx-cart').setAttribute('aria-hidden','true');
  $('#bx-cart-veil').classList.remove('is-open');
}
/* The button reads "Add complete system to cart" — so it has to actually put the
   lines in Shopify's cart, not just open the preview drawer. That was the trap:
   the drawer showed a total, the customer left the page, and the cart was empty. */
function openAndSave(){
  const {m2, allOff} = bomAll();
  if(!state.areas.length || !m2 || !state.colour){ requireReady(); return; }
  openCart();
  /* Nothing left to add — adding would silently empty the Shopify cart and look like
     the button is broken. Show the drawer with the restore control instead. */
  if(allOff){ setSaved('is-err', 'Every item is excluded. Put them back, or start over, before adding to your cart.'); return; }
  saveToCart(false);
}
$('#bx-cart-btn').addEventListener('click', openAndSave);
$('#bx-cart-btn-2').addEventListener('click', openAndSave);
$('#bx-cart-close').addEventListener('click', closeCart);
$('#bx-cart-veil').addEventListener('click', ()=>{ closeCart(); closeEst(); });
document.addEventListener('keydown', e=>{ if(e.key==='Escape'){ closeCart(); closeEst(); } });
/* ── REAL Shopify cart, not just this drawer ────────────────────────────
   The drawer is a preview; the cart that survives leaving the page is
   Shopify's. syncCart() clears whatever this page put in the cart before
   (every line carries Project: 'Renovation Experience') and re-adds the
   current BOM, so pressing Add twice never duplicates and the items are
   still there when the customer comes back. */
const RE_TAG = 'Renovation Experience';
const jfetch = (url, opts) => fetch(url, Object.assign({headers:{'Content-Type':'application/json','Accept':'application/json'}}, opts||{}));

function cartLines(){
  const {groups} = bomAll();
  const pc = state.colour ? colourBy(state.colour, state.depth) : null;
  const fin = state.finish ? FINISHES.find(f=>f.key===state.finish).name : 'To decide with installer';
  const items = [];
  groups.forEach(({k, items: its})=>{
    its.filter(i=>!state.removed[i.key]).forEach(i=>{
      items.push({ id: i.id, quantity: i.qty, properties: {
        'Project': RE_TAG,
        'Area': area(k).label,
        'Colour': pc ? `${pc.name} (${pc.code}) · ${state.depth}` : '',
        'Finish': fin
      }});
    });
  });
  return items;
}
/* zero out only the lines this page owns — anything else in the cart stays */
function dropOurLines(){
  return jfetch('/cart.js').then(r => r.ok ? r.json() : null).then(cart => {
    if(!cart) return;
    const updates = {};
    (cart.items || []).forEach(li => {
      if(li.properties && li.properties.Project === RE_TAG) updates[li.key] = 0;
    });
    if(!Object.keys(updates).length) return;
    return jfetch('/cart/update.js', {method:'POST', body: JSON.stringify({updates})});
  });
}
/* Every sync is drop-then-add, so two of them running at once can interleave into a
   half-written cart — the second drop wipes what the first just added. Three quick
   Remove clicks were enough to empty the cart. Serialise them: each sync waits for
   the one before it, and a failure never stalls the queue. */
let syncChain = Promise.resolve();
function syncCart(){
  syncChain = syncChain.then(runSync, runSync);
  return syncChain;
}
function runSync(){
  const items = cartLines();
  return dropOurLines()
    .then(()=> items.length ? jfetch('/cart/add.js', {method:'POST', body: JSON.stringify({items})}) : null)
    .then(res => { if(res && !res.ok) throw new Error('cart'); return jfetch('/cart.js').then(r=>r.json()); })
    .then(cart => { paintCartCount(cart.item_count); return cart; });
}
function paintCartCount(n){
  const el = $('#bx-cartcount'); if(!el) return;
  el.textContent = n > 99 ? '99+' : n;
  el.hidden = !n;
}
/* the project needs areas + measurements + a colour before it can be ordered */
const REQ_MSG = {
  1: 'Required: select at least one project area to continue.',
  4: 'Required: choose a colour — your system is tinted to order, so we can\'t add it to the cart without one.',
  6: 'Required: enter the size of at least one surface so we can calculate quantities.'
};
function clearRequired(){
  document.querySelectorAll('.bx-step.is-required').forEach(s=>s.classList.remove('is-required'));
  document.querySelectorAll('.bx-require').forEach(el=>el.remove());
  const m = document.getElementById('bx-req-msg'); if(m){ m.hidden = true; m.textContent=''; }
}
function flagRequired(step){
  clearRequired();
  const sec = document.getElementById('bx-step-'+step); if(!sec) return;
  sec.classList.add('is-required');
  const head = sec.querySelector('.bx-step__head > div') || sec.querySelector('.bx-step__head');
  const note = document.createElement('p'); note.className='bx-require'; note.setAttribute('role','alert');
  note.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>' + REQ_MSG[step];
  head.appendChild(note);
  const m = document.getElementById('bx-req-msg');
  if(m){ m.innerHTML = REQ_MSG[step] + ' <a href="#bx-step-'+step+'">Go to step '+step+' &uarr;</a>'; m.hidden = false; }
  sec.scrollIntoView({behavior:'smooth'});
}
function requireReady(){
  const {m2} = bomAll();
  let miss = 0;
  if(!state.areas.length) miss = 1;
  else if(!m2) miss = 6;
  else if(!state.colour) miss = 4;
  if(!miss){ clearRequired(); return true; }
  closeCart(); closeEst();
  flagRequired(miss);
  return false;
}
let cartSaved = false, saveTimer = null;
/* Anything that changes the project re-syncs Shopify. The empty case matters most:
   saveToCart() bails out through requireReady() when there are no areas left, which
   used to mean that once lines were in the cart nothing on this page could ever take
   them out again — deselecting every area left the cart full and the badge counting.
   When the project empties we push that straight through syncCart(). */
function markCartDirty(){
  if(!cartSaved) return;
  clearTimeout(saveTimer);
  saveTimer = setTimeout(()=>{
    const {m2} = bomAll();
    if(!state.areas.length || !m2){ syncCart().catch(()=>{}); return; }
    saveToCart(true);
  }, 700);
}
/* Wipes the project: every selection on this page and every line this page put in the
   Shopify cart. Anything the customer added from elsewhere in the store is untouched. */
function clearProject(){
  const tab = state.tab;
  state = Object.assign(structuredClone(DEFAULT_STATE), {tab});
  cartSaved = false;
  save();
  document.querySelectorAll('#bx-depth button').forEach(x=>x.classList.toggle('is-on', x.dataset.depth===state.depth));
  renderAreas(); renderPalettes(); renderFamilies(); renderSwatches();
  renderAllGrid(); renderPicked(); renderFinishes(); renderDerived(); renderCart();
  const el = $('#bx-cart-saved'); if(el) el.hidden = true;
  return dropOurLines()
    .then(()=> jfetch('/cart.js'))
    .then(r => r && r.ok ? r.json() : null)
    .then(c => { if(c) paintCartCount(c.item_count); })
    .catch(()=>{});
}
/* Two taps to empty, so nobody loses a measured-up project to a stray click. */
function wireClearAll(btn, label){
  if(!btn) return;
  let armed = false, t = null;
  btn.addEventListener('click', ()=>{
    if(!armed){
      armed = true; btn.classList.add('is-confirm');
      btn.dataset.idle = btn.innerHTML;
      btn.textContent = 'Tap again to empty everything';
      t = setTimeout(()=>{ armed = false; btn.classList.remove('is-confirm'); btn.innerHTML = btn.dataset.idle; }, 4000);
      return;
    }
    clearTimeout(t); armed = false;
    btn.classList.remove('is-confirm'); btn.innerHTML = btn.dataset.idle;
    clearProject().then(()=>{
      closeCart();
      document.getElementById('bx-step-1').scrollIntoView({behavior:'smooth'});
    });
  });
}
function setSaved(cls, msg){
  const el = $('#bx-cart-saved'); if(!el) return;
  el.hidden = false; el.className = 'bx-cart-saved ' + cls; el.textContent = msg;
}
function saveToCart(quiet){
  if(!requireReady()) return Promise.resolve(false);
  if(!quiet) setSaved('is-busy', 'Saving to your cart…');
  return syncCart().then(cart => {
    cartSaved = true;
    const n = cart.item_count;
    setSaved('is-ok', '✓ Saved to your cart — ' + n + (n===1?' item':' items') + '. Keep browsing; it will still be here when you come back.');
    return true;
  }).catch(() => {
    cartSaved = false;
    setSaved('is-err', 'We could not save this to your cart. Please try again.');
    return false;
  });
}
function doCheckout(btn){
  if(!requireReady()) return;
  btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding your system…';
  syncCart().then(()=>{ window.location.href = '/checkout'; }).catch(()=>{
    btn.disabled = false; btn.textContent = btn.dataset.label || 'Checkout →';
    alert('Sorry — we could not add your system to the cart. Please try again.');
  });
}
$('#bx-checkout').addEventListener('click', function(){ doCheckout(this); });
$('#bx-save').addEventListener('click', function(){ saveToCart(false); });
/* show what is already in the cart the moment the page loads */
jfetch('/cart.js').then(r=>r.ok?r.json():null).then(c=>{
  if(!c) return;
  paintCartCount(c.item_count);
  if((c.items||[]).some(li => li.properties && li.properties.Project === RE_TAG)) cartSaved = true;
}).catch(()=>{});

/* ── INSTALLATION ESTIMATE — lead capture → labor estimate, same page ──
   Labor-only $/m² ranges for QLD East Coast pro installers, derived from
   2026 AU market data (installed microcement $200–$500/m² incl. materials;
   wet areas carry waterproofing detail, benchtops are small-area premium). */
/* Breno 2026-08-20: price labor at AT LEAST $250/m² — every bucket floors there. */
const LABOR_RATES = {
  wallDry:  {label:'Internal walls & ceilings', low:250, high:325},
  floorDry: {label:'Internal floors',           low:250, high:325},
  wet:      {label:'Wet areas (waterproofed)',  low:275, high:400},
  outdoor:  {label:'Outdoor & facades',         low:260, high:360},
  bench:    {label:'Benchtops & joinery',       low:300, high:450}
};
const LABOR_MIN_JOB = 1800;
const LEAD_WEBHOOK = 'https://n8n.brenoimprover.com/webhook/mf-labor-leads';

function laborBuckets(){
  const b = {wallDry:0, floorDry:0, wet:0, outdoor:0, bench:0};
  state.areas.forEach(k=>{
    const a = area(k);
    (state.rows[k]||[]).forEach(r=>{
      const m = rowM2(r); if(!m) return;
      if(a.ctx.outdoor) b.outdoor += m;
      else if(a.ctx.wet) b.wet += m;
      else if(r.t==='benchtop') b.bench += m;
      else if(r.t==='floor') b.floorDry += m;
      else b.wallDry += m;
    });
  });
  return b;
}
function laborEstimate(){
  const b = laborBuckets();
  let low = 0, high = 0; const parts = [];
  Object.keys(b).forEach(key=>{
    if(b[key] <= 0) return;
    const r = LABOR_RATES[key];
    low += b[key]*r.low; high += b[key]*r.high;
    parts.push({label:r.label, m2:b[key], low:b[key]*r.low, high:b[key]*r.high});
  });
  if(low > 0) low = Math.max(low, LABOR_MIN_JOB);
  return {low: Math.round(low), high: Math.round(high), parts};
}
const isServiced = pc => /^4\d{3}$/.test(pc);

function openEst(){
  const {m2} = bomAll();
  if(!state.areas.length || !m2){ closeCart(); document.getElementById('bx-step-'+(!state.areas.length?1:6)).scrollIntoView({behavior:'smooth'}); return; }
  closeCart();
  const sel = state.areas.map(k=>area(k).label).join(' + ');
  $('#bx-est-meta').textContent = `${m2.toFixed(1)} m² · ${sel} · Queensland's East Coast`;
  // returning lead: prefill the form
  try{
    const saved = JSON.parse(localStorage.getItem('bx-lead')||'null');
    if(saved){ ['name','email','phone','postcode'].forEach(f=>{ const el=$('#bx-est-'+f); if(el && !el.value) el.value = saved[f]||''; }); }
  }catch(e){}
  $('#bx-est').classList.add('is-open');
  $('#bx-est').setAttribute('aria-hidden','false');
  $('#bx-cart-veil').classList.add('is-open');
}
function closeEst(){
  const el = $('#bx-est'); if(!el) return;
  el.classList.remove('is-open');
  el.setAttribute('aria-hidden','true');
  if(!$('#bx-cart').classList.contains('is-open')) $('#bx-cart-veil').classList.remove('is-open');
}
/* Loading transition: the estimate "builds" in front of the person — sells why
   we asked for their details (a written copy goes to their inbox). */
function showEstLoading(lead, done){
  $('#bx-est-intro').hidden = true;
  const w = $('#bx-est-result'); w.hidden = false;
  w.innerHTML = `<div class="bx-est-loading">
      <span class="bx-est-spin" aria-hidden="true"></span>
      <p id="bx-est-loadmsg">Measuring your surfaces…</p>
    </div>`;
  const msgs = ['Measuring your surfaces…', 'Matching expert installer rates…', 'Preparing your written copy for ' + lead.email + '…'];
  let i = 0;
  const t = setInterval(()=>{
    i++;
    if(i < msgs.length){ const el = $('#bx-est-loadmsg'); if(el) el.textContent = msgs[i]; }
    else { clearInterval(t); done(); }
  }, 700);
}

function renderEstResult(lead){
  const {m2, cost} = bomAll();
  const est = laborEstimate();
  const ok = isServiced(lead.postcode);
  const money0 = n => '$'+Math.round(n).toLocaleString('en-AU');
  const hasCom = state.areas.some(k=>area(k).tab==='com');
  $('#bx-est-intro').hidden = true;
  const w = $('#bx-est-result'); w.hidden = false;
  w.innerHTML = `
    <p class="bx-est-sub" style="margin:2px 0 0">Done, ${lead.name.split(' ')[0]} — your estimate is below, and a written copy is headed to <b>${lead.email}</b>.</p>
    <p class="bx-est-range"><em>${money0(est.low)}</em> – ${money0(est.high)}</p>
    <p class="bx-est-sub">Professional labor for ${m2.toFixed(1)} m², by our expert installer network.</p>
    <div class="bx-est-rows">
      ${est.parts.map(p=>`<div class="bx-est-row"><span>${p.label} · ${p.m2.toFixed(1)} m²</span><span>${money0(p.low)} – ${money0(p.high)}</span></div>`).join('')}
      <div class="bx-est-row"><span>Materials (your system, incl. GST)</span><span>${money(cost)}</span></div>
      <div class="bx-est-row is-total"><span>Estimated project total</span><span>${money0(est.low+cost)} – ${money0(est.high+cost)}</span></div>
    </div>
    <div class="bx-est-flag ${ok?'is-ok':'is-warn'}">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 auto;margin-top:1px">${ok?'<path d="M20 6 9 17l-5-5"/>':'<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5v.5"/>'}</svg>
      <span>${ok
        ? `Postcode ${lead.postcode} is inside our Queensland East Coast installer network — we'll match you with the right expert installer.`
        : `Postcode ${lead.postcode} is outside our core Queensland network — we'll confirm coverage or connect you with a trusted partner.`}</span>
    </div>
    ${hasCom ? '<p class="bx-est-fine">Commercial project noted — volume pricing usually lands sharper per m²; your final quote reflects that.</p>' : ''}
    <div class="bx-est-up">
      <h4>Make your quote sharper</h4>
      <p>Add your floor plan, moodboard or inspiration photos — your installer quotes with real context, not guesses.</p>
      <label class="bx-est-drop" for="bx-est-files">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4m0 0 4 4m-4-4-4 4"/><path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>
        <span>Click to add your files</span>
        <em>Floor plans · moodboards · photos · PDF or images · up to 3 files, 8&nbsp;MB total</em>
      </label>
      <input type="file" id="bx-est-files" multiple accept="image/*,application/pdf" hidden>
      <div class="bx-est-filelist" id="bx-est-filelist"></div>
      <button class="bx-btn bx-btn--line bx-btn--big" style="width:100%" id="bx-est-sendfiles" type="button" hidden>Send my files →</button>
    </div>
    <button class="bx-btn bx-btn--green bx-btn--big" style="width:100%" id="bx-est-checkout" type="button">Continue to checkout →</button>
    <p class="bx-est-fine">Estimate only — your final quote is confirmed by the installer after a quick site check. Your written estimate is emailed within 1 business day and one of our team calls to confirm. Materials ship Queensland-wide either way.</p>`;
  $('#bx-est-checkout').addEventListener('click', function(){ doCheckout(this); });
  bindEstUploads(lead);
}

/* ── file uploads (floor plan / moodboard / ideas) → same webhook, kind:'files' ── */
function bindEstUploads(lead){
  const input = $('#bx-est-files'), list = $('#bx-est-filelist'), send = $('#bx-est-sendfiles');
  if(!input) return;
  let picked = [];
  const MAX_FILES = 3, MAX_TOTAL = 8 * 1024 * 1024;
  input.addEventListener('change', ()=>{
    picked = [...input.files].slice(0, MAX_FILES);
    const total = picked.reduce((s,f)=>s+f.size, 0);
    if(total > MAX_TOTAL){
      list.innerHTML = '<span class="bx-est-file is-err">Files are over 8 MB total — try fewer or smaller files.</span>';
      send.hidden = true; picked = []; return;
    }
    list.innerHTML = picked.map(f=>`<span class="bx-est-file">${f.name} <em>${(f.size/1024/1024).toFixed(1)} MB</em></span>`).join('');
    send.hidden = picked.length === 0;
  });
  send.addEventListener('click', ()=>{
    if(!picked.length) return;
    send.disabled = true; send.textContent = 'Sending…';
    Promise.all(picked.map(f => new Promise((res, rej)=>{
      const r = new FileReader();
      r.onload = ()=>res({ name: f.name, mime: f.type || 'application/octet-stream', data: String(r.result).split(',')[1] || '' });
      r.onerror = rej;
      r.readAsDataURL(f);
    }))).then(files =>
      fetch(LEAD_WEBHOOK, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ kind:'files', ...lead, source:'renovation-experience', url: location.href, files })
      })
    ).then(r=>{
      if(!r.ok) throw new Error('upload');
      send.textContent = 'Files sent ✓ — your installer sees them with your estimate';
    }).catch(()=>{
      send.disabled = false; send.textContent = 'Send my files →';
      alert('Sorry — the files did not go through. Please try again.');
    });
  });
}
$('#bx-est-btn').addEventListener('click', openEst);
$('#bx-est-btn-2').addEventListener('click', openEst);
$('#bx-est-close').addEventListener('click', closeEst);
$('#bx-est-form').addEventListener('submit', e=>{
  e.preventDefault();
  const lead = {
    name: $('#bx-est-name').value.trim(),
    email: $('#bx-est-email').value.trim(),
    phone: $('#bx-est-phone').value.trim(),
    postcode: $('#bx-est-postcode').value.trim()
  };
  const bad = !lead.name || !/.+@.+\..+/.test(lead.email) || lead.phone.length < 8 || !/^\d{4}$/.test(lead.postcode);
  $('#bx-est-err').hidden = !bad;
  if(bad) return;
  try{ localStorage.setItem('bx-lead', JSON.stringify(lead)); }catch(e){}
  const {m2, cost} = bomAll();
  const est = laborEstimate();
  const pc = state.colour ? colourBy(state.colour, state.depth) : null;
  // fire-and-forget: the estimate never waits on the network
  try{
    fetch(LEAD_WEBHOOK, {
      method:'POST', headers:{'Content-Type':'application/json'}, keepalive:true,
      body: JSON.stringify({
        kind:'lead', ...lead, funnel:'labor', source:'renovation-experience',
        areas: state.areas, m2_total: Math.round(m2*10)/10,
        colour: pc ? `${pc.name} (${pc.code}) · ${state.depth}` : '',
        finish: state.finish ? FINISHES.find(f=>f.key===state.finish).name : '',
        materials_subtotal: Math.round(cost*100)/100,
        labor_low: est.low, labor_high: est.high,
        serviced: isServiced(lead.postcode), url: location.href
      })
    }).catch(()=>{});
  }catch(e){}
  showEstLoading(lead, ()=>renderEstResult(lead));
});
$('#bx-palclear').addEventListener('click', ()=>{ state.palette=null; save(); renderPalettes(); renderFamilies(); renderSwatches(); });
$('#bx-pal-prev').addEventListener('click', ()=>{ $('#bx-pal-track').scrollBy({left:-300, behavior:'smooth'}); });
$('#bx-pal-next').addEventListener('click', ()=>{ $('#bx-pal-track').scrollBy({left:300, behavior:'smooth'}); });

/* ── tabs / depth / view-all wiring ─────────────────────── */
document.querySelectorAll('.bx-tab').forEach(t=>t.addEventListener('click', ()=>{
  state.tab = t.dataset.tab; save();
  document.querySelectorAll('.bx-tab').forEach(x=>x.setAttribute('aria-selected', x===t ? 'true':'false'));
  renderAreas();
}));
document.querySelectorAll('#bx-depth button').forEach(b=>b.addEventListener('click', ()=>{
  state.depth = b.dataset.depth; state.palette = null; save();
  document.querySelectorAll('#bx-depth button').forEach(x=>x.classList.toggle('is-on',x===b));
  renderPalettes(); renderFamilies(); renderSwatches(); renderPicked(); renderSummary();
}));
$('#bx-viewall-btn').addEventListener('click', ()=>{
  const g = $('#bx-allgrid'), open = g.classList.toggle('is-open');
  $('#bx-viewall-btn').setAttribute('aria-expanded', open);
});

$('#bx-restore-all') && $('#bx-restore-all').addEventListener('click', restoreAll);
wireClearAll($('#bx-clearall'));
wireClearAll($('#bx-startover-1'));

/* ── reveal on scroll ──────────────────────────────────── */
const io = new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target);} }),{threshold:.08});
document.querySelectorAll('.bx-reveal').forEach(el=>io.observe(el));

/* ── boot ──────────────────────────────────────────────── */
document.querySelectorAll('.bx-tab').forEach(x=>x.setAttribute('aria-selected', x.dataset.tab===state.tab ? 'true':'false'));
document.querySelectorAll('#bx-depth button').forEach(x=>x.classList.toggle('is-on',x.dataset.depth===state.depth));
renderAreas(); renderPalettes(); renderFamilies(); renderSwatches(); renderAllGrid(); renderPicked(); renderFinishes(); renderDerived();


/* ── consultation pop-up (2026-09-16) ─────────────────────────
   "Book a consultation" used to anchor-scroll to the bottom band. Now it opens the
   same drawer pattern as the estimate, prefilled with whatever the person already
   typed (estimate form or a saved lead), posts to the lead webhook and shows a
   thank-you with a "keep shopping" exit. */
(function(){
  const modal = $('#bx-consult-modal'); if(!modal) return;
  const form = $('#bx-consult-form');
  function prefill(){
    let saved = null; try{ saved = JSON.parse(localStorage.getItem('bx-lead')||'null'); }catch(e){}
    ['name','email','phone','postcode'].forEach(f=>{
      const el = $('#bx-consult-'+f); if(!el || el.value) return;
      const est = $('#bx-est-'+f);
      el.value = (est && est.value.trim()) || (saved && saved[f]) || '';
    });
    const {m2} = bomAll();
    const sel = state.areas.map(k=>area(k).label).join(' + ');
    $('#bx-consult-meta').textContent = m2 ? `${m2.toFixed(1)} m² · ${sel} · free 15-min call` : 'Free · 15 minutes · we call you';
  }
  function openConsult(){
    closeCart(); closeEst();
    $('#bx-consult-intro').hidden = false; $('#bx-consult-done').hidden = true;
    prefill();
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false');
    $('#bx-cart-veil').classList.add('is-open');
    setTimeout(()=>{ const first = ['name','email','phone'].map(f=>$('#bx-consult-'+f)).find(el=>el && !el.value); (first || $('#bx-consult-name')).focus(); }, 60);
  }
  function closeConsult(){
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true');
    if(!$('#bx-cart').classList.contains('is-open')) $('#bx-cart-veil').classList.remove('is-open');
  }
  document.querySelectorAll('[data-bx-consult]').forEach(a=>a.addEventListener('click', e=>{ e.preventDefault(); openConsult(); }));
  $('#bx-consult-close').addEventListener('click', closeConsult);
  $('#bx-cart-veil').addEventListener('click', ()=>{ if(modal.classList.contains('is-open')) closeConsult(); });
  document.addEventListener('keydown', e=>{ if(e.key==='Escape' && modal.classList.contains('is-open')) closeConsult(); });
  $('#bx-consult-keep').addEventListener('click', closeConsult);
  $('#bx-consult-tocart').addEventListener('click', ()=>{ closeConsult(); openAndSave(); });
  form.addEventListener('submit', e=>{
    e.preventDefault();
    const lead = {
      name: $('#bx-consult-name').value.trim(),
      email: $('#bx-consult-email').value.trim(),
      phone: $('#bx-consult-phone').value.trim(),
      postcode: $('#bx-consult-postcode').value.trim(),
      message: $('#bx-consult-msg').value.trim()
    };
    const bad = !lead.name || !/.+@.+\..+/.test(lead.email) || lead.phone.replace(/\D/g,'').length < 8;
    $('#bx-consult-err').hidden = !bad;
    if(bad) return;
    try{ localStorage.setItem('bx-lead', JSON.stringify({name:lead.name,email:lead.email,phone:lead.phone,postcode:lead.postcode})); }catch(e){}
    const btn = $('#bx-consult-send'); btn.disabled = true; btn.textContent = 'Sending…';
    const {m2, cost} = bomAll();
    const pc = state.colour ? colourBy(state.colour, state.depth) : null;
    const payload = {
      kind:'lead', ...lead, funnel:'consultation', source:'renovation-experience',
      areas: state.areas, m2_total: Math.round(m2*10)/10,
      colour: pc ? `${pc.name} (${pc.code}) · ${state.depth}` : '',
      finish: state.finish ? FINISHES.find(f=>f.key===state.finish).name : '',
      materials_subtotal: Math.round(cost*100)/100,
      serviced: lead.postcode ? isServiced(lead.postcode) : null, url: location.href
    };
    const finish = ()=>{
      btn.disabled = false; btn.textContent = 'Request my consultation →';
      $('#bx-consult-intro').hidden = true; $('#bx-consult-done').hidden = false;
      $('#bx-consult-done-copy').textContent = `Thanks ${lead.name.split(' ')[0]} — your project details are with our team. Expect a call or email within 1 business day.`;
      $('#bx-consult-tocart').hidden = !(state.areas.length && m2 && state.colour);
    };
    fetch(LEAD_WEBHOOK, { method:'POST', headers:{'Content-Type':'application/json'}, keepalive:true, body: JSON.stringify(payload) })
      .then(finish).catch(finish); // the thank-you never waits on the network
  });
})();
